import React from "react";
import {Helmet} from "react-helmet-async";
import {
    BackLink,
    ContactLine,
    DownloadCard,
    Steps,
    SupportHeading,
    SupportLayout,
    useDownloadFlow,
} from "../components/support/SupportUI";
import {useRustdeskInfo} from "../components/support/rustdesk";

const SupportWindows = () => {
    const api = useRustdeskInfo();
    const flow = useDownloadFlow(api, "windows");

    return (
        <SupportLayout>
            <Helmet>
                <title>Fernwartung für Windows | Dockline Digital</title>
                <meta name="robots" content="noindex, nofollow"/>
            </Helmet>

            <SupportHeading eyebrow="Fernwartung · Windows" title="RustDesk für Windows"/>

            <DownloadCard {...flow}/>

            <Steps>
                <li>
                    <strong>Datei öffnen.</strong> Bitte ändern Sie den Dateinamen nicht, darin steckt die
                    Verbindung zu unserem Server.
                </li>
                <li>
                    <strong>Bestätigen.</strong> Falls Windows nachfragt, klicken Sie auf „Ja“ bzw. „Ausführen“.
                </li>
                <li>
                    <strong>Uns Bescheid geben.</strong> Nennen Sie uns die angezeigte ID und das Passwort.
                </li>
            </Steps>

            <ContactLine/>
            <BackLink>Sie nutzen einen Mac?</BackLink>
        </SupportLayout>
    );
};

export default SupportWindows;
